import { get,post } from "../ajax";

interface saveActivityType {
    id: string,
    name: string,
    description: string,
    status: number,
    imageUrl: string,
    cycle: number,
    cycleTotal: number
    supplyChannelId: number,
    instructions: string,
    instructionsImg: string,
    receiveMode: string,
    participants: number,
    cardImg: string,
    backgroundImg: string,
    cycleNum: number,
    // delayCollectionDay: number
}

export interface selectProductType {
    productId: number | string,
    productName: string
}

interface product {
    id: number,
    activityId: number,
    activityCycleId: number,
    productId: number,
    productName: string,
    inventory: number
}

interface cycleData {
    id: number,
    activityId: number,
    name: string,
    optionalNum: number,
    optionalTotal: number,
    activityCycleProductDatas: product[]
}

export interface cycleProductType {
    activityId: number,
    activityCycleDatas: cycleData[]
}
export async function activityList(body:Record<string, any>){
    const url = `/api/Activity/GetActivityPageList?Name=${body.Name}&PageIndex=${body.PageIndex}&PageSize=${body.PageSize}`
    const res = await get(url)
    return res;
}

export async function activityDetail(id:number){
    const url = `/api/Activity/GetActivityDetail?id=${id}`
    const res = await get(url)
    return res;
}

export async function activityCycleAndProductList(id:number){
    const url = `/api/Activity/GetActivityCycleAndProductList?id=${id}`
    const res = await get(url)
    return res;
}

export async function saveActivity(body:saveActivityType){
    const url = `/api/Activity/SaveActivity`
    const res = await post(url,body)
    return res;
}

export async function saveActivityCycleAndProduct(body:cycleProductType){
    const url = `/api/Activity/SaveActivityCycleAndProduct`
    const res = await post(url,body)
    return res;
}


export async function saveActivityStatus(body:{activityId:number,status:number}){
    const url = `/api/Activity/SaveActivityStatus`
    const res = await post(url,body)
    return res;
}

export async function deleteActivity(body:{activityId:number}){
    const url = `/api/Activity/DeleteActivity`
    const res = await post(url,body)
    return res;
}

export async function copyPrivWrap(activityId:number){
    const url = `/api/Activity/CopyActivity`
    const res = await post(url,{activityId})
    return res;
}

export async function cancelActivity(activityId:number){
    const url = `/api/Activity/CancelActivity`
    const res = await post(url,{activityId})
    return res;
}

export async function productStockInfo(ActivityId :number|string,ProductId:number){
    const url = `/api/Product/GetProductStockInfo?ActivityId=${ActivityId}&ProductId=${ProductId}`
    const res = await get(url)
    return res;
}

interface productType {
    id: number,
    activityId: number,
    productId: number,
    productName: string,
    inventory: number,
    privilegePrice: number,
    orderNum: number,
    collectTimeLimit: string,
    collectTimeValidity: number
}

export interface activityProductType {
    activityId: number,
    productList: productType[]
  }

// 简化
export async function activityProductList(id:number){
    const url = `/api/Activity/GetActivityCycleProductList?id=${id}`
    const res = await get(url)
    return res;
}

export async function saveActivityProduct(body:activityProductType){
    const url = `/api/Activity/SaveActivityProduct`
    const res = await post(url,body)
    return res;
}

export async function selectActivityList(){
    const url = `/api/Activity/GetSelectActivityList`
    const res = await get(url)
    return res;
}